module.exports = __webpack_public_path__ + "img/contactsImg2x.png";